module.exports = __webpack_public_path__ + "src/assets/img/ic13.109d6c3a.svg";